import { useEffect, useState } from "react";
import { Button } from "@mui/material";
import api from "../../../../services/api";
import HeaderSession from "../../../../utils/headerSession";
// import Loading from "../../../../load/loading";
import SearshEstabelecimento from "../../../../utils/searchEstabelecimento";
import Pagincao from "../../../../utils/paginacao";
import ListaSolicitacao from "./listaSolicitacao";
import RegisterAccess from "../../../../utils/registerAccess";
import { SolicitacoesLicenciamentoReprovadosExcel } from "../../../exports/gerarelatorioexcel";
import { SolicitacaoLicenciamentoReprovadosPdf } from "../../../exports/gerarelatoriopdf";
import { useSearchParams } from "react-router-dom";
import TabelaLoading from "../../../../load/tabelaLoading";

export default function SolicitacoesReprovadas() {
  // const user = useSelector(state => state.account.user);
  const [tipo, setTipo] = useState("");
  const [status, setStatus] = useState("");
  const [provincia, setProvincia] = useState("");
  const [estabelecimentos, setEstabelecimentos] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [order, setOrder] = useState("");
  const [loading, setLoading] = useState(false);
  const [configLista, setConfigLista] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(searchParams.get("page"));
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [filtroInspeccao, setFiltroInspeccao] = useState(searchParams.get("filtroInspeccao") || "todos");

  useEffect(() => {
    const filtroUrl = searchParams.get("filtroInspeccao") || "todos";
    if (filtroUrl !== filtroInspeccao) {
      setFiltroInspeccao(filtroUrl);
    }
  }, [searchParams]);


  useEffect(() => {
    setLoading(true);
    setEstabelecimentos("");
    const statusInspeccaoParam = filtroInspeccao === 'inspeccaoReprovada' ? '&statusInspeccao=Reprovada' : '';

    api.get(`/estabelecimentos?page=${page}&status=Reprovado${statusInspeccaoParam}&perPage=${perPage}&tipoId=${tipo}&status=${status}&dataInicio=${dataInicio}&dataFim=${dataFim}&provincia=${provincia}&sortBy=dataDespacho:ASC`) //&sortBy=nome:${order}
      .then((response) => {
        setEstabelecimentos(response.data.estabelecimentos);
        setConfigLista(response.data);
        // setEstabelecimentos((prevItems) => [
        //   ...prevItems,
        //   ...response.data.estabelecimentos,
        // ]);
        

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, [page, perPage, order, tipo, status, provincia, dataInicio, dataFim, filtroInspeccao]);

  const handleChangeFiltroInspeccao = (novoFiltro) => {
    setFiltroInspeccao(novoFiltro);
    setPage(1);

    const params = new URLSearchParams(searchParams);
    params.set("page", "1");
    params.set("filtroInspeccao", novoFiltro);
    setSearchParams(params);
  };

  return (
    <>
      <RegisterAccess page={"solicitações reprovadas"} />

      <HeaderSession
        title="LISTA DE PROCESSOS REPROVADOS"
        actions={true}
        handleExportExcel={() => SolicitacoesLicenciamentoReprovadosExcel(estabelecimentos)}
        handleExportPDF={() => SolicitacaoLicenciamentoReprovadosPdf(estabelecimentos)}
      />

      <div className="tw-mb-4 tw-flex tw-flex-wrap tw-gap-2">
        <Button
          variant={filtroInspeccao === 'todos' ? 'contained' : 'outlined'}
          color="secondary"
          onClick={() => handleChangeFiltroInspeccao('todos')}
        >
          Todos os reprovados
        </Button>
        <Button
          variant={filtroInspeccao === 'inspeccaoReprovada' ? 'contained' : 'outlined'}
          color="secondary"
          onClick={() => handleChangeFiltroInspeccao('inspeccaoReprovada')}
        >
          Só inspeção reprovada
        </Button>
      </div>

      <SearshEstabelecimento
        setEstabelecimentos={setEstabelecimentos}
        setTipo={setTipo}
        setStatus={setStatus}
        setProvincia={setProvincia}
        setDataInicio={setDataInicio}
        setDataFim={setDataFim}
        dataInicio={dataInicio}
        dataFim={dataFim}
        statuss={status}
        provincia={provincia}
        tipo={tipo}
        placeholder={"Filtra por nome, número de entrada, data"}
      />

      {estabelecimentos && (
        <ListaSolicitacao
          estabelecimentos={estabelecimentos}
          setEstabelecimentos={setEstabelecimentos}
          tipo={tipo}
          setTipo={setTipo}
          provincia={provincia}
          setProvincia={setProvincia}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
          dataInicio={dataInicio}
          dataFim={dataFim}
        >

          <Pagincao
            configLista={configLista}
            lista={estabelecimentos}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
            setOrder={setOrder}
          />
        </ListaSolicitacao>

      )}

      {loading && <TabelaLoading />}
    </>
  );
}
